import Plugin from "@ckeditor/ckeditor5-core/src/plugin";
import ButtonView from "@ckeditor/ckeditor5-ui/src/button/buttonview";

export default class LSUploadLibraryGallery extends Plugin {
    init() {
        // on récupère l'objet editor de l'éditeur
        const editor = this.editor;
        // sur la propriété ui l'éditeur on invoque la compenentFactory pour créer un bouton
        editor.ui.componentFactory.add("ls_upload_library_gallery", (locale) => {
            // 'ls_upload_library_gallery' est le nom du bouton à déclarer dans la barre d'outils de l'éditeur
            // on crée un bouton
            const button = new ButtonView(locale);

            // on défini le label du bouton
            button.set({
                label: "GALERIE",
                withText: true,
                tooltip: true,
            });

            // on écoute l'événement de click sur le bouton et on invoque la fonction _fetchBloc()
            this.listenTo(button, "execute", () => {
                const event = new CustomEvent("ckAddUploadLibraryGallery", {
                    detail: {
                        editor: editor,
                        type: "upload_library_gallery",
                    },
                });
                document.dispatchEvent(event);
            });
            return button;
        });
    }
}
